/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Section_ArticleInputs */

const en_directory_detail_section_article = /** @type {(inputs: Directory_Detail_Section_ArticleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full review`)
};

const zh_directory_detail_section_article = /** @type {(inputs: Directory_Detail_Section_ArticleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整评测`)
};

/**
* | output |
* | --- |
* | "Full review" |
*
* @param {Directory_Detail_Section_ArticleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_section_article = /** @type {((inputs?: Directory_Detail_Section_ArticleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Section_ArticleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_section_article(inputs)
	return zh_directory_detail_section_article(inputs)
});
export { directory_detail_section_article as "directory.detail.section.article" }